import { _ep0, _mw0, command } from "../commandBuilder";
import { AddManagerToChurch$ } from "../schemas/schemas_0";
export class AddManagerToChurchCommand extends command(_ep0, _mw0, "AddManagerToChurch", AddManagerToChurch$) {
}
